var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Carga",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "tipo_cargo",
      "label-for": "tipo_cargo",
      "label": "Tipo da Carga"
    }
  }, [_c('VueSelect', {
    ref: "tipo_cargo",
    class: {
      hasErrors: _vm.tipoCargoError
    },
    attrs: {
      "filterable": false,
      "searchable": false,
      "options": _vm.tipoCargas
    },
    on: {
      "input": function input() {
        return _vm.tipoCargoError = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.tipo_cargo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipo_cargo", $$v);
      },
      expression: "form.tipo_cargo"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o tipo de carga ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "produto_predominante",
      "label-for": "produto_predominante",
      "label": "Produto Dominante"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "50",
      "autofocus": "",
      "state": _vm.validateState('produto_predominante')
    },
    model: {
      value: _vm.form.produto_predominante,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "produto_predominante", $$v);
      },
      expression: "form.produto_predominante"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "valor_cargo",
      "label-for": "valor_cargo",
      "label": "Valor Carga R$"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "state": _vm.validateState('valor_cargo')
    },
    model: {
      value: _vm.form.valor_cargo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valor_cargo", $$v);
      },
      expression: "form.valor_cargo"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "peso_cargo",
      "label-for": "peso_cargo",
      "label": "Peso"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "state": _vm.validateState('peso_cargo')
    },
    model: {
      value: _vm.form.peso_cargo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "peso_cargo", $$v);
      },
      expression: "form.peso_cargo"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "peso_unidade_cargo",
      "label-for": "peso_unidade_cargo",
      "label": "Unidade de medida"
    }
  }, [_c('VueSelect', {
    ref: "selectTipoEmissor",
    class: {
      hasErrors: _vm.unidadeError
    },
    attrs: {
      "filterable": false,
      "options": _vm.unidadesPeso
    },
    on: {
      "input": function input() {
        return _vm.unidadeError = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.peso_unidade_cargo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "peso_unidade_cargo", $$v);
      },
      expression: "form.peso_unidade_cargo"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };